<template>
    <div class="background1"> Just do it</div>
</template>

<script>
export default {
name:'topBg'
}
</script>

<style scoped>
.background1{
  margin-bottom: 20px;
  text-align: center;
  font:  bold 30px/254px sans-serif;
  background: url('./img/nav.jpg') no-repeat center/cover;
}
</style>